const REQUEST_CACHE_PREFIX = 'tcode_request_cache_'
const REQUEST_CACHE_TTL = 10 * 60 * 1000 // 10 минут

const CACHEABLE_PATTERNS = [
    /\/shops\/?(\?.*)?$/,      // списки точек продаж
    /\/suppliers\/?(\?.*)?$/,  // поставщики
    /\/categories\/?(\?.*)?$/, // категории
]

export function isCacheableRequest(url) {
    return CACHEABLE_PATTERNS.some((re) => re.test(url))
}

function cacheKey(url) {
    return REQUEST_CACHE_PREFIX + url
}

export function getCachedRequest(url) {
    try {
        const raw = localStorage.getItem(cacheKey(url))
        if (!raw) return null
        const parsed = JSON.parse(raw)
        if (!parsed._time || Date.now() - parsed._time > REQUEST_CACHE_TTL) return null
        return parsed.data
    } catch (e) {
        return null
    }
}

export function cacheRequest(url, data) {
    try {
        localStorage.setItem(cacheKey(url), JSON.stringify({ data, _time: Date.now() }))
    } catch (e) {
        // ignore
    }
}

export function clearRequestCache() {
    try {
        const keys = []
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i)
            if (key && key.startsWith(REQUEST_CACHE_PREFIX)) keys.push(key)
        }
        keys.forEach((k) => localStorage.removeItem(k))
    } catch (e) {
        // ignore
    }
}